{
  "LOGIN": {
    "TITLE": "Innskráning í þjónustuver",
    "EMAIL": {
      "LABEL": "Tölvupóstfang",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Vinsamlegast skrifaðu gilt netfang"
    },
    "PASSWORD": {
      "LABEL": "Lykilorð",
      "PLACEHOLDER": "Lykilorð"
    },
    "API": {
      "SUCCESS_MESSAGE": "Innskráning tókst",
      "ERROR_MESSAGE": "Náði ekki að tengjast við netþjóna Woot, vinsamlegast reynið aftur",
      "UNAUTH": "Notandanafn / lykilorð rangt. Vinsamlegast reyndu aftur",
      "ACCOUNT_DEACTIVATED": "Reikningnum þínum hefur verið lokað. Vinsamlegast hafðu samband við stjórnanda þinn.",
      "PASSWORD_LOGIN_DISABLED": "Innskráning með lykilorði er óvirk fyrir reikninginn þinn. Vinsamlegast skráðu þig inn með OAuth (t.d. Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Login with Google",
      "BUSINESS_ACCOUNTS_ONLY": "Please use your company email address to login",
      "NO_ACCOUNT_FOUND": "We couldn't find an account for your email address."
    },
    "FORGOT_PASSWORD": "Gleymt lykilorð?",
    "CREATE_NEW_ACCOUNT": "Stofna nýjan aðgang",
    "SUBMIT": "Innskráning"
  }
}
